const observer = new IntersectionObserver(function (entries, observer) {
	entries.forEach(function (entry) {
		if (entry.intersectionRatio > 0) {
			entry.target.classList.add('animate__animated', entry.isIntersecting);
			entry.target.classList.add('animate__fadeInUp', entry.isIntersecting); // entry.target.classList.add('animate__fast', entry.isIntersecting);
		}
	});
});
document.querySelectorAll('.feature-section').forEach(function (el) {
	observer.observe(el);
});

document.querySelectorAll('.wp-block-media-text').forEach(function (el) {
	observer.observe(el);
});

document.querySelectorAll('.animate-fadeInUp').forEach(function (el) {
	observer.observe(el);
});
